// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1oDlF","approved":"Status_approved__2gds5","rejected":"Status_rejected__3B82j","expired":"Status_expired__-T-RA","label":"Status_label__3pr-y"};